<template>
  <div>
    <template v-if="!emailSent">
      <default-layout
        :title="t('AuthenticatedPage.RequireEmailVerification.heading')"
        :sub-title="userIdentity.email"
      >
        <div
          data-test="verify-email-prompt-detail"
          v-html="t('AuthenticatedPage.RequireEmailVerification.detail', { email: userIdentity.email, contactSupportUrl })"
        />

        <div class="my-6">
          <sm-button
            type="primary"
            @click="sendEmailVerification"
          >
            {{ t('AuthenticatedPage.RequireEmailVerification.sendEmailVerification') }}
          </sm-button>
        </div>
      </default-layout>
    </template>
    <template v-else>
      <default-layout
        :title="t('AuthenticatedPage.CheckEmailVerification.heading')"
        :sub-title="userIdentity.email"
      >
        <div
          data-test="verify-email-prompt-detail"
          v-html="t('AuthenticatedPage.CheckEmailVerification.detail')"
        />

        <div class="my-6">
          <sm-button
            type="primary"
            @click="emailSent=false"
          >
            {{ t('AuthenticatedPage.CheckEmailVerification.didNotReceiveTheEmail') }}
          </sm-button>
        </div>
      </default-layout>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { createNamespacedHelpers } from 'vuex-composition-helpers'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import { client } from '@/services/beef'
import { useI18n } from '../../setup/setup-i18n'

const { useState: useUserStoreState } = createNamespacedHelpers('User')
const { useGetters: useLoginDomainStoreGetter } = createNamespacedHelpers('contactSupportUrl')

export default defineComponent({

  name: 'AuthenticatedRequireEmailVerification',

  components: { DefaultLayout },

  setup() {

    const { userIdentity } = useUserStoreState(['userIdentity'])
    const { contactSupportUrl } = useLoginDomainStoreGetter(['contactSupportUrl'])
    const { t } = useI18n()

    const emailSent = ref(false)

    const sendEmailVerification = async () => {

      await client.sendUserVerification({
        path: { email: userIdentity.value?.email },
      })
      emailSent.value = true

    }

    return {
      t,
      emailSent,
      userIdentity,
      contactSupportUrl,
      sendEmailVerification,
    }

  },

})

</script>

<style lang="scss" scoped>
// TODO fix tailwind and remove these
.my-6 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
// these are style overrides for the sui components to make them look similar to the previous sputnik components.
// TODO: remove these overrides once we implement new screens.
.sm-button {
  @apply w-full;
}

::v-deep .sm-button__content {
  @apply justify-center;
}

::v-deep .page_title .container p {
  // increase the font weight of PageTitle.subTitle
  @apply font-semibold;
}
</style>
